import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import i18n from '../../i18n';
import brandLogo from '../../assets/logo-centre-jour.png';
import LegalFooter from './LegalFooter';

const NavIcon = ({ path }) => {
  const icons = {
    '/': <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg>,
    '/profile': <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>,
    '/staff': <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" /></svg>,
    '/schedule': <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>,
    '/monthly-program': <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h6m-6 4h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>,
    '/leaves': <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" /></svg>,
    '/timeclock': <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
    '/badges': <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h10v10H7zM9 9h2m0 3h2m0-3h2m-6 6h6" /></svg>,
    '/patients': <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" /></svg>,
    '/activities': <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 9h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>,
    '/activity-catalog': <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h7l5 5v11a2 2 0 01-2 2z" /></svg>,
    '/transport': <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17h6m-6 0a2 2 0 11-4 0m4 0a2 2 0 104 0m4 0a2 2 0 104 0m-1-8l-2.5-3.5A2 2 0 0016.87 5H10a2 2 0 00-2 2v8m0 0h10M3 11h3" /></svg>,
    '/incidents': <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M10.29 3.86l-8 14A1 1 0 003.15 19h17.7a1 1 0 00.86-1.5l-8-14a1 1 0 00-1.72 0z" /></svg>,
    '/centers': <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>,
    '/permissions': <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
    '/privacy-incidents': <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M5 6h14a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2zm3-3h6a1 1 0 011 1v2H8V4a1 1 0 011-1z" /></svg>,
    '/reports': <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>,
  };
  return icons[path] || null;
};

const Layout = () => {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [brandLogoError, setBrandLogoError] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const rawNavItems = [
    { path: '/', label: t('nav.dashboard'), always: true },
    { path: '/badges', label: t('nav.badges'), roles: ['admin', 'manager'] },
    { path: '/schedule', label: t('nav.schedule'), roles: ['admin', 'manager', 'staff'] },
    { path: '/monthly-program', label: i18n.language.startsWith('fr') ? 'Calendrier mensuel' : 'Monthly calendar', roles: ['admin', 'manager', 'staff', 'usager'] },
    { path: '/leaves', label: t('nav.leaves'), roles: ['admin', 'manager', 'staff'] },
    { path: '/staff', label: t('nav.staff'), roles: ['admin', 'manager'] },
    { path: '/patients', label: t('nav.patients'), roles: ['admin', 'manager', 'staff', 'usager'] },
    { path: '/activities', label: t('nav.activities'), roles: ['admin', 'manager', 'staff', 'usager'] },
    { path: '/activity-catalog', label: t('nav.activityCatalog'), roles: ['admin'] },
    { path: '/transport', label: t('nav.transport'), roles: ['admin', 'manager', 'staff', 'usager'] },
    { path: '/incidents', label: t('nav.incidents'), roles: ['admin', 'manager', 'staff'] },
    { path: '/centers', label: t('nav.centers'), roles: ['admin'] },
    { path: '/permissions', label: t('nav.permissions'), roles: ['admin'] },
    { path: '/privacy-incidents', label: t('nav.privacyIncidents'), roles: ['admin'] },
    { path: '/reports', label: t('nav.reports'), roles: ['admin', 'manager', 'staff', 'usager'] },
    { path: '/profile', label: t('nav.settings'), always: true },
  ];

  const visibleNavItems = rawNavItems.filter(
    item => item.always || (item.roles && item.roles.includes(user?.role))
  );

  const dashboardItem = visibleNavItems.find(item => item.path === '/');
  const sortedOtherItems = visibleNavItems
    .filter(item => item.path !== '/')
    .sort((a, b) => a.label.localeCompare(b.label, i18n.language || 'fr', { sensitivity: 'base' }));
  const navItems = dashboardItem ? [dashboardItem, ...sortedOtherItems] : sortedOtherItems;

  const initials = user ? `${user.firstName?.[0]}${user.lastName?.[0]}` : '?';

  return (
    <div className="layout">
      <a className="skip-link" href="#main-content">{t('accessibility.skipToContent')}</a>
      {sidebarOpen && (
        <div
          aria-hidden="true"
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 99 }}
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`} aria-label={t('accessibility.sidebarNav')}>
        <div className="sidebar-logo">
          {!brandLogoError ? (
            <img
              src={brandLogo}
              alt="Logo Centre de Jour"
              className="sidebar-brand-logo"
              onError={() => setBrandLogoError(true)}
            />
          ) : (
            <div className="logo-icon">🏥</div>
          )}
          <h1>{t('appName')}</h1>
          <p>{t('appSubtitle')}</p>
        </div>

        <nav id="primary-navigation" className="sidebar-nav" aria-label={t('accessibility.primaryNav')}>
          {navItems.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/'}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <NavIcon path={item.path} />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-bottom">
          <div className="user-card">
            <div className="user-avatar">{initials}</div>
            <div className="user-info">
              <div className="user-name">{user?.firstName} {user?.lastName}</div>
              <div className="user-role">{t(`roles.${user?.role}`)}</div>
            </div>
          </div>
          <button
            className="nav-item"
            style={{ marginTop: 8, color: '#f87171' }}
            onClick={handleLogout}
          >
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{ width: 18, height: 18 }}>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            {t('nav.logout')}
          </button>
        </div>
      </aside>

      <main className="main-content">
        <header className="topbar">
          <button
            type="button"
            aria-label={sidebarOpen ? t('accessibility.closeMenu') : t('accessibility.openMenu')}
            aria-expanded={sidebarOpen}
            aria-controls="primary-navigation"
            style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', padding: 4, borderRadius: 8 }}
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="mobile-menu-btn"
          >
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{ width: 24, height: 24 }}>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <div />
          <div className="topbar-actions">
            <div className="lang-toggle" role="group" aria-label={t('accessibility.languageSelector')}>
              <button
                type="button"
                className={i18n.language.startsWith('fr') ? 'active' : ''}
                aria-pressed={i18n.language.startsWith('fr')}
                onClick={() => i18n.changeLanguage('fr')}
              >
                FR
              </button>
              <button
                type="button"
                className={i18n.language.startsWith('en') ? 'active' : ''}
                aria-pressed={i18n.language.startsWith('en')}
                onClick={() => i18n.changeLanguage('en')}
              >
                EN
              </button>
            </div>
          </div>
        </header>

        <div id="main-content" className="page-content" tabIndex="-1">
          <Outlet />
        </div>
        <LegalFooter />
      </main>
    </div>
  );
};

export default Layout;
